import { AccountSyncOutlineIcon } from './AccountSyncOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 4D5C282D-E452-4544-BD36-6EBF5DE7FD85
 * name account-sync-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-sync-outline.svg
 * tags
 * - Account / User 
 */
export const AccountCacheOutlineIcon = AccountSyncOutlineIcon;
export default AccountCacheOutlineIcon